var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-container"},[_c('Slideshow',{attrs:{"autoPlay":"","intervalSeconds":_vm.tributeVideo?.webSlideshowSlideSeconds,"slides":_vm.slides},on:{"slide-duration":_vm.handleSlideDurationUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }